import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { Button } from '@/components/ui/Button/button';
import openModal from '@/modals/utils/openModal';
import lockDailyWidget from '@/public/assets/image/daily-bonuses/lock-daily-widget.webp';

const DailyBonusGuestOverlay = () => {
  const t = useTranslations('daily-bonus');
  return (
    <div className="absolute inset-0 z-10 flex h-full flex-col items-center justify-between overflow-hidden rounded-2xl bg-[rgba(35,19,51,0.75)] p-4 text-center backdrop-blur-[7px]">
      <div className="flex w-full flex-col items-center gap-3 max-md:mt-2">
        <Image src={lockDailyWidget} alt="Lock" className="shrink-0 size-16.25 md:size-18" />
        <div className="flex w-full flex-col items-center gap-2 md:gap-1">
          <p className="w-full font-semibold text-white text-base leading-[120%] md:text-[0.75rem] md:leading-4">{t('sign-up-to-unlock-daily-bonuses')}</p>
          <p className="text-[0.75rem] text-white leading-4 font-medium md:text-[0.625rem] flex items-center gap-1">
            {t('earn-up-to')}
            <span className="font-semibold text-[1.125rem] leading-7 text-transparent bg-clip-text bg-main-front-gradient md:text-base md:leading-[120%]">75 SC</span>
            {t('every-day')}
          </p>
        </div>
      </div>
      <Button variant="primary" size="lg" className="w-full py-3 px-4 md:py-1.5" onClick={() => openModal('register')}>
        {t('sign-up-and-claim')}
      </Button>
    </div>
  );
};
export default DailyBonusGuestOverlay;
